module.exports = __webpack_public_path__ + "static/media/fondo_sin_nubes.049dea8d.png";